<template>
  <NavbarNavigationContainer />
</template>


<script>
import { NavbarNavigationContainer } from "./containers/exporter.js";

export default {
  name: "navbar",
  components: { NavbarNavigationContainer },
};
</script>
